<template>
  <div class="addBtn" :class="{ 'disabled-icon': disabled }" @click="showDialog = true && !disabled">
    + Add Hormones / Medications
  </div>
  <el-dialog
    v-model="showDialog"
    center
    title="Add Hormones / Medications"
    modal-class="hormoneDialog"
  >
    <div class="flex flex-col">
      <div class="medicationFormLine">
        <div class="medicationLabel">Hormone Type<span>*</span></div>
        <el-input
          class="medicationInput"
          v-model="this.medicationRecords.hormoneType"
        />
      </div>
      <div class="medicationFormLine">
        <div class="medicationLabel">Brand</div>
        <el-input
          class="medicationInput"
          v-model="this.medicationRecords.brand"
        />
      </div>
      <div class="medicationFormLine">
        <div class="medicationLabel">Delivery</div>
        <el-input
          class="medicationInput"
          v-model="this.medicationRecords.delivery"
        />
      </div>
      <div class="medicationFormLine">
        <div class="medicationLabel">Dosage</div>
        <el-input
          class="medicationInput"
          v-model="this.medicationRecords.dosage"
        />
      </div>
      <div class="medicationFormLine">
        <div class="medicationLabel">Last Used Date</div>
        <el-input
          class="medicationInput"
          placeholder="YYYY-MM-DD"
          v-model="this.medicationRecords.lastUsedDate"
          @input="formatDate"
        />
      </div>
      <div class="medicationFormLine">
        <div class="medicationLabel">Last Used Time</div>
        <el-input
          class="medicationInput"
          placeholder="HH:MM"
          v-model="this.medicationRecords.lastUsedTime"
          @input="formatTime"
        />
      </div>
      <div class="medicationFormLine">
        <div class="medicationLabel">Times Per Day</div>
        <el-input
          class="medicationInput"
          v-model="this.medicationRecords.timesPerDay"
        >
          <template #suffix>
            <span>Times</span>
          </template>
        </el-input>
      </div>
      <div class="medicationFormLine">
        <div class="medicationLabel">How Long Used</div>
        <el-input
          class="medicationInput"
          v-model="this.medicationRecords.howLongUsed"
        />
      </div>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button class="cancelBtn" @click="this.closeHormoneDialog"
          >Cancel</el-button
        >
        <el-button
          class="submitBtn"
          @click="this.confirmUpdateMedicationRecords"
          :disabled="!this.medicationRecords.hormoneType"
        >
          Confirm
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: "AddHormoneDialog",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showDialog: false,
      medicationRecords: {
        hormoneType: "",
        brand: "",
        delivery: "",
        dosage: "",
        lastUsedDate: "",
        lastUsedTime: "",
        timesPerDay: "",
        howLongUsed: "",
      },
    };
  },
  emits: ["addToMedicationHistory"],
  methods: {
    confirmUpdateMedicationRecords() {
      this.$emit("addToMedicationHistory", this.medicationRecords);
      this.closeHormoneDialog();
    },
    formatDate(value) {
      let cleanValue = value.replace(/\D/g, "");
      let formattedValue = "";

      if (cleanValue.length > 8) {
        cleanValue = cleanValue.slice(0, 8);
      }

      if (cleanValue.length > 4) {
        formattedValue = `${cleanValue.slice(0, 4)}-${cleanValue.slice(4)}`;
        if (cleanValue.length > 6) {
          formattedValue = `${formattedValue.slice(0, 7)}-${formattedValue.slice(7)}`;
        }
      } else {
        formattedValue = cleanValue;
      }
      
      this.medicationRecords.lastUsedDate = formattedValue;
    },
    formatTime(value) {
      let cleanValue = value.replace(/\D/g, "");
      let formattedValue = "";

      if (cleanValue.length > 4) {
        cleanValue = cleanValue.slice(0, 4);
      }

      if (cleanValue.length > 2) {
        formattedValue = `${cleanValue.slice(0, 2)}:${cleanValue.slice(2)}`;
      } else {
        formattedValue = cleanValue;
      }
      
      this.medicationRecords.lastUsedTime = formattedValue;
    },
    closeHormoneDialog() {
      this.medicationRecords = {
        hormoneType: "",
        brand: "",
        delivery: "",
        dosage: "",
        lastUsedDate: "",
        lastUsedTime: "",
        timesPerDay: "",
        howLongUsed: "",
      };
      this.showDialog = false;
    },
  },
};
</script>

<style scoped>
.addBtn {
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0.175px;
  text-align: left;
  color: #20a8c3;
  text-decoration: underline;
  cursor: pointer;
  margin-top: 12px;
}

.medicationFormLine {
  display: flex;
  align-items: center;
  margin-top: 12px;
  justify-content: space-between;
  width: 600px;
}

.medicationLabel {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0.17px;
  text-align: left;
}

.medicationLabel span {
  color: #ff1d00;
  margin-left: 4px;
}

.medicationInput {
  width: 400px;
  height: 42px;
  margin-left: 20px;
}

:deep(.el-dialog__title) {
  font-family: Roboto;
  font-size: 24px;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0.175px;
  text-align: center;
  color: #0e4672;
}

:deep(.el-input__suffix) {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0.4px;
  text-align: left;
  color: #0e4672 !important;
  margin-right: 20px;
  display: flex;
  align-items: center;
  filter: none !important;
}

.howLongUsedContainer {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  border: 1px solid #bcccdc;
  border-radius: 4px;
  width: 400px;
  height: 42px;
  margin-left: 20px;
}


.howLongUsedInput {
  height: 30px;
}

:deep(.medicationInput .el-input__inner) {
  color: #000000 !important;
  caret-color: #000000;
  margin-left: 0px;
  height: 42px;
}

:deep(.howLongUsedInput .el-input__inner) {
  border: none !important;
  padding-left: 10px;
}

.el-button.submitBtn.is-disabled {
  background: #f3f3f3 !important;
  border: 1px solid #f3f3f3 !important;
  color: #bbbbbb !important;
}

.el-button.submitBtn {
  background: #5cbec6 !important;
  border: 1px solid #5cbec6 !important;
  color: #ffffff !important;
}

.el-button.submitBtn:hover {
  background: #87dfe6 !important;
  border: 1px solid #87dfe6 !important;
}

.el-button.cancelBtn {
  color: #5cbec6 !important;
  border: 2px solid #5cbec6 !important;
  background: #ffffff !important;
}

.el-button.cancelBtn:hover {
  color: #87dfe6 !important;
  border: 2px solid #5cbec6 !important;
  outline: 1px solid #ffffff;
  outline-offset: -2px;
}

@media only screen and (max-width: 808px) {
  .medicationFormLine {
    flex-direction: column;
    width: 90vw;
  }

  .medicationInput {
    width: 80vw;
    margin-left: 0px;
  }

  :deep(.el-input__suffix) {
    font-size: 14px;
  }

  .howLongUsedContainer {
    width: 80vw;
    margin-left: 0px;
  }

  .medicationLabel {
    font-size: 14px !important;
    width: 90% !important;
  }

  .el-input {
    font-size: 14px;
  }

  .cancelBtn,
  .submitBtn {
    width: 30vw !important;
    font-size: 14px !important;
    max-width: 166px;
  }
}
</style>
